import styled from "styled-components";
export const ProductionLinesWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
